import { z } from 'zod';
/**
 * Báo cáo dấu hiệu bất thường trong số liệu hiệu suất — APM-ACHEAT-g.
 *
 * ## Đây là danh sách để NGƯỜI xem lại, không phải kết luận
 *
 * Mỗi dòng là một *mẫu hành vi* lặp đủ số lần trong cửa sổ — và mọi mẫu ở đây
 * đều có cách giải thích vô tội: ba việc xong trong mười phút có thể là dọn
 * board sau một ngày quên kéo thẻ; dời hạn ba lần có thể là phụ thuộc trượt.
 * Nên báo cáo nói "đáng nhìn lại", kèm đúng những việc để nhìn, và dừng ở đó.
 * Không điểm số, không xếp hạng, không gắn vào hồ sơ hiệu suất.
 *
 * Tính **lúc đọc** từ `event_log` và `work_session`, không có bảng riêng và
 * không có job: một danh sách cho vài người quản lý mở mỗi tháng không đáng một
 * bảng dẫn xuất nữa phải xin ngoại lệ luật #1.
 */
export const AnomalyKind = z.enum([
    /** ≥ N việc chuyển sang xong bởi cùng một người trong `RAPID_COMPLETION_WINDOW_MINUTES`. */
    'rapid_completions',
    /** Một việc bị cùng một người dời hạn **muộn hơn** ≥ N lần. */
    'repeated_reschedule',
    /** Người làm tự bật cờ "bị chặn" trên việc của mình ≥ N lần. */
    'self_block',
    /** Nâng ước lượng rồi đóng việc trong vòng `ESTIMATE_BUMP_WINDOW_HOURS` ≥ N lần. */
    'estimate_bump_before_done',
    /** Đoạn bấm giờ bị job đóng vì chạm trần (12h / trần ngày) ≥ N lần. */
    'timesheet_at_cap',
]);
export const AnomalyRow = z.object({
    kind: AnomalyKind,
    userId: z.uuid(),
    /** `null` khi người đó đã rời tổ chức. */
    userName: z.string().nullable(),
    /** Số lần mẫu xuất hiện trong cửa sổ. */
    count: z.number().int().positive(),
    /** Mã việc liên quan (`APM-12`), tối đa `ANOMALY_TASK_KEYS` cái, để bấm vào xem. */
    taskKeys: z.array(z.string()),
    /** Lần gần nhất. */
    lastAt: z.iso.datetime(),
});
export const AnomalyReport = z.object({
    from: z.iso.datetime(),
    to: z.iso.datetime(),
    rows: z.array(AnomalyRow),
    /** Ngưỡng đang áp cho từng mẫu — giao diện nói ra để người đọc biết "≥ 3" là đâu ra. */
    thresholds: z.record(AnomalyKind, z.number().int().positive()),
    /** `true` khi cửa sổ có nhiều event hơn trần đọc; kết quả là một phần. */
    truncated: z.boolean(),
});
/** Cửa sổ mặc định: 30 ngày — một kỳ đánh giá. */
export const ANOMALY_WINDOW_DAYS = 30;
/** Ngưỡng tối thiểu để một mẫu thành dòng. Dưới ngưỡng là chuyện thường. */
export const ANOMALY_THRESHOLDS = {
    rapid_completions: 3,
    repeated_reschedule: 3,
    self_block: 3,
    estimate_bump_before_done: 2,
    timesheet_at_cap: 3,
};
export const RAPID_COMPLETION_WINDOW_MINUTES = 10;
export const ESTIMATE_BUMP_WINDOW_HOURS = 24;
export const ANOMALY_TASK_KEYS = 5;
//# sourceMappingURL=anomaly.js.map